var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockLong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 5.5H2.625C2.38338 5.5 2.1875 5.72386 2.1875 6V13C2.1875 13.2761 2.38338 13.5 2.625 13.5H11.375C11.6166 13.5 11.8125 13.2761 11.8125 13V6C11.8125 5.72386 11.6166 5.5 11.375 5.5Z",
    stroke: "#F40909",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03125 5.5V3.25C5.03125 2.65326 5.23867 2.08097 5.60788 1.65901C5.9771 1.23705 6.47786 1 7 1C7.52214 1 8.0229 1.23705 8.39212 1.65901C8.76133 2.08097 8.96875 2.65326 8.96875 3.25V5.5",
    stroke: "#F40909",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.25C7.36244 10.25 7.65625 9.91421 7.65625 9.5C7.65625 9.08579 7.36244 8.75 7 8.75C6.63756 8.75 6.34375 9.08579 6.34375 9.5C6.34375 9.91421 6.63756 10.25 7 10.25Z",
    fill: "#F40909"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockLong);
export default __webpack_public_path__ + "static/media/LockLong.3f4ed57f2d4c7ed2f26fecaa27bdf69d.svg";
export { ForwardRef as ReactComponent };